import React from "react";
import "./errorMessage.css";

const ErrorMessage = (props) => {
  const { message, inline } = props;
  // Nothing to say -> render nothing. The styled box (padding + background from the global
  // .error-message rule) otherwise shows up as an empty coloured square next to the buttons.
  if (!message) return null;
  return (
    <div
      className="error-message"
      style={{
        color: "red",
        display: !inline ? "block" : "inline-block",
        ...props.style,
      }}
    >
      {message}
    </div>
  );
};

export default ErrorMessage;
